import * as OrganizationAPIAdapter from '../adapters/organizationApi.adapter';

const getOrganizations = async ({
  skip,
  limit,
}: {
  skip: number;
  limit: number;
}) => {
  return OrganizationAPIAdapter.getOrganizations({ skip, limit });
};

const getOrganization = async () => {
  return OrganizationAPIAdapter.getOrganization();
};

export default {
  getOrganizations,
  getOrganization,
};
